import React, { useEffect, useState, useRef } from 'react';
import '../main.css';
import WrappedMap from './Map';
import config from '../../config';
// import { paths, stops } from "../../utils/data"
import { FaLocationDot } from "react-icons/fa6";
import { FaRegClock } from "react-icons/fa";
// import { FaBus } from "react-icons/fa";
import Navbar from '../navbar/Navbar';
import { apiCall } from '../../../service';

const Main = () => {

  const [vehicleData, setVehicleData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [vehicleSpeed, setVehicleSpeed] = useState();
  const [vehicleNumber, setVehicleNumber] = useState();
  const [address, setAddress] = useState('');
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mapVisible, setMapVisible] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  const [boardingPoint, setBoardingPoint] = useState("")
  const [eta, setEta] = useState(null)

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [isMobileMapVisible, setIsMobileMapVisible] = useState(false);

  const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_MAP_KEY}`;


  const vehicleRefs = useRef([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768); 
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const codeToken = params.get('code');
    const isLoggedIn = localStorage.getItem('isAuthenticated')
    setIsAuthenticated(isLoggedIn);
    const authToken = async () => {
      if (codeToken && !isAuthenticated) {
        const payload = {
          method: 'POST',
          Authorization: `Bearer ${codeToken}`,
          host: config.apiEndpoints.userAuthToken.host,
          endPoint: config.apiEndpoints.userAuthToken.url,
        };

        try {
          const data = await apiCall(payload);

          if (data.staus) {
            localStorage.setItem("isAuthenticated", true)
            const newUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
            setIsAuthenticated(true)
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    authToken();
  }, [isAuthenticated]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          host: config.apiEndpoints.vehicleList.host,
          endPoint: config.apiEndpoints.vehicleList.url,
          method: "GET",
        };
        const response = await apiCall(payload);
        setVehicleData(response.data.rows);
        setLoading(false);

        if (selectedVehicleId) {
          const selectedVehicle = response.data.rows.find(vehicle => vehicle.uid === selectedVehicleId);
          if (selectedVehicle) {
            setVehicleSpeed(selectedVehicle.speed);
            setVehicleNumber(selectedVehicle.vehicle);
            setAddress(selectedVehicle.location || 'N/A')
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error.message);
      }
    };

    if (isAuthenticated) {
      fetchData();
    }

    const intervalId = setInterval(() => {
      if (isAuthenticated) {
        fetchData();
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [selectedVehicleId, isAuthenticated]);

  const getVehicleData = async (vehicleNo) => {
    try {
      const payload = {
        host: config.apiEndpoints.getVehiclelocation.host,
        endPoint: config.apiEndpoints.getVehiclelocation.url,
        method: "POST",
        body: {
          vehicleNo: vehicleNo,
        },
      };
      const response = await apiCall(payload);
      if (response && response.hop) {
        const etaTime = response.hop.ETA.split('T')[1];
        const [hours, minutes] = etaTime.split(':');
        setEta(`${hours}hrs ${minutes}min` || "NA");
        setBoardingPoint(response.hop.AddressBook?.address || "NA");
      } else {
        setEta("NA");
        setBoardingPoint("NA");
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
      setEta("NA");
      setBoardingPoint("NA");
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (selectedVehicleId !== null) {
        const selectedVehicle = vehicleData.find(vehicle => vehicle.uid === selectedVehicleId);
        if (selectedVehicle) {
          getVehicleData(selectedVehicle.vehicle);
        }
      }
    }, 60000);
    return () => clearInterval(intervalId);
  }, [selectedVehicleId, vehicleData]);

  const filteredVehicles = vehicleData.filter((vehicle) =>
    vehicle.vehicle.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleRenderMap = async (speed, number, uid) => {
    setVehicleSpeed(speed);
    setVehicleNumber(number);
    setSelectedVehicleId(uid);
    setMapVisible(true);
    setRerender(!rerender);
    setIsMobileMapVisible(true);
    await getVehicleData(number);
  };

  useEffect(() => {
    if (isMobileMapVisible && selectedVehicleId !== null && isMobile) {
      // Wait for the vehicleRefs to be updated before scrolling
      const index = vehicleData.findIndex(vehicle => vehicle.uid === selectedVehicleId);
      if (index >= 0 && vehicleRefs.current[index]) {
        vehicleRefs.current[index].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }, [isMobileMapVisible, selectedVehicleId, vehicleData, isMobile]);

  // const handleRedirectJob = () =>{
  //   console.log("handleRedirectJob clicked")
  // }

  return (
    <div className="App">
      <Navbar
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        placeholder="Search vehicle..."
        showFilter={showFilter}
      />
      {
        loading ?
          // <div className='loader_main'>
          //   <div className="loader"></div>
          // </div>
          <div className="loader-wrapper">
            <div className="truck-wrapper">
              <div className="truck">
                <div className="truck-container"></div>
                <div className="glases"></div>
                <div className="bonet"></div>

                <div className="base"></div>

                <div className="base-aux"></div>
                <div className="wheel-back"></div>
                <div className="wheel-front"></div>

                <div className="smoke"></div>
              </div>
            </div>
          </div>
          :
          <div className='main_container'>
            <div className={`vehicle_detail ${isMobileMapVisible ? 'fullheight' : 'semiHeight'}`}>
              <div>
                {filteredVehicles.length > 0 ? (
                  filteredVehicles.map((vehicle, index) => (
                    <div key={index} className="vehicle_container"
                      onClick={() => { handleRenderMap(Math.round(vehicle.speed), vehicle.vehicle, vehicle.uid, index) }}
                      ref={(el) => vehicleRefs.current[index] = el}>
                      <div className='vehicle_detail_card' style={{
                        backgroundColor: vehicle.speed === "0" ? "#c7812c" : "#4CAF50",
                        border: vehicle.speed === "0" ? "1px solid #c7812c" : "1px solid #4CAF50",
                      }}>
                        <p className='vehicle_number_container'>
                          <p style={{
                            color: "white",
                            backgroundColor: vehicle.speed === "0" ? "#c7812c" : "#4CAF50",
                          }}>{vehicle.vehicle}</p>
                          <p className='vehicle_uid'>{vehicle.uid}</p>
                        </p>
                      </div>
                      <p className='vehicle_data'>
                        <span style={{ marginTop: "2px" }}><FaRegClock /></span>
                        <span style={{ color: vehicle.speed === "0" ? "#c7812c" : "#4CAF50" }}>
                          {vehicle.gpsupdatedtime.replace('T', ' ').split('.')[0]}
                        </span>
                        <span style={{ fontWeight: "bold" }}>Speed </span>
                        :
                        <span style={{ color: vehicle.speed === "0" ? "#c7812c" : "#4CAF50" }}>
                          {Math.round(vehicle.speed)} km/h
                        </span>
                      </p>
                      {/* <p className='vehicle_data'>
                        <span style={{ marginTop: "2px" }}><FaBus /></span>
                        {vehicle.vehicleinfo}
                      </p> */}
                      <p className='' style={{ marginTop: "5px", marginBottom: "5px" }}>
                        <span><FaLocationDot /></span>
                        <span style={{ fontWeight: "bold", marginRight: "5px" }}>Location</span>
                        :
                        <span>{vehicle.location}</span>
                      </p>
                      {/* <p className='' style={{ marginTop: "5px", marginBottom: "5px" }}>
                        <span><FaBus /></span>
                        <span style={{ fontWeight: "bold", marginRight: "5px" }}>Assigned Job</span>
                        :
                        <span style={{ fontWeight:"bold" , color:"green" , marginLeft:"5px" , textDecoration:"underline"}} onClick={handleRedirectJob}>1998</span>
                      </p> */}
                    </div>
                  ))
                ) : (
                  <p>No matching vehicles found</p>
                )}
              </div>
            </div>
            <div className={`vehicle_location ${isMobileMapVisible ? 'show' : ''}`} key={rerender}>
              {mapVisible || isMobileMapVisible ? (
                <>
                  <WrappedMap
                    // paths={paths}
                    // stops={stops}
                    speed={vehicleSpeed}
                    vehicleNo={vehicleNumber}
                    address={address}
                    googleMapURL={mapURL}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div className='mapContainer' />}
                    mapElement={<div style={{ height: `100%` }} />}
                  />
                  <div className='sideTile'>
                    <div>
                      <h3>Vehicle Position</h3>
                      <p><span className='color_green'>Speed: </span> {Math.round(vehicleSpeed)} km/hr</p>
                      <p><span className='color_green'>Location: </span> {address}</p>
                      <p><span className='color_green'>Vehicle No: </span> {vehicleNumber}</p>
                      <p><span className='color_green'>Next Dropping Point: </span>{boardingPoint}</p>
                      <p><span className='color_green'>ETA: </span>{eta}</p>
                    </div>
                  </div>
                </>
              ) : (
                <div className="no-vehicle-selected">
                  <p>Select a vehicle to see live tracking
                    <span className="loading-dots">
                      <span>.</span><span>.</span><span>.</span>
                    </span>
                  </p>
                </div>
              )}
            </div>
          </div>
      }
    </div>
  );
}

export default Main;